module.exports = __webpack_public_path__ + "img/kk-active.79dcfeaf.png";